module.exports = __webpack_public_path__ + "lo-matching-banner-f0c36d97/LO_summary_Ger-818cee2271ccf72f0f4637a47676543f.svg";